<!-- 普通用户或者管理员的后台管理页面左侧菜单栏 -->
<template>
<div class="nav-wrapper">
  <div class="asideLogo v_tc" style="font-size:20px;">{{collapse &&'AI'||'AI Open Platform &nbsp;&nbsp;&nbsp;&nbsp;'}}</div>
  <!-- <div class="asideLogo v_tc">
    <img width="36" :src="nav_logo" alt="" srcset="">
    <span v-if="!collapse">身份宝人证核验授权平台</span>
  </div> -->
  <el-menu ref="menuNav" :collapse="collapse" :style="{width:pageSize.navWidth+'px'}" class="el-menu-demo" text-color="#272626" active-text-color="#2d8cf0" :default-active="active" @select="hanldeMenu">
    <template v-for="(item,index) in menuList">
        <el-submenu v-if="item.children && item.children.length > 1" :index="`${item.name}-${index}`" :key="item.name">
          <template slot="title">
            <i :class="item.icon" style="font-size:16px"></i>
            <span>{{showLang(item.name)}}</span>
</template>
      <el-menu-item v-for="item in item.children" :index="item.name" :key="item.name">{{showLang(item.name)}}</el-menu-item>
      </el-submenu>
      <el-menu-item v-else-if="item.children && item.children.length === 1" :key="item.name" :index="item.name">
      <i :class="item.icon" style="font-size:16px"></i>
      <span slot="title">{{showLang(item.name)}}</span>
    </el-menu-item>
    <el-menu-item v-else :key="item.name" :index="item.name">
      <i :class="item.icon" style="font-size:16px"></i>
      <span slot="title">{{showLang(item.name)}}</span>
    </el-menu-item>
    </template>
  </el-menu>
</div>
</template>

<script>
import nav_logo from '@/assets/img/nav_logo.png';
export default {
  name: "",
  props: {
    menuList: {
      type: Array,
      default: []
    },
    pageSize: {
      type: Object,
      default: {}
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nav_logo,
      oldIndex: "",
    };
  },
  computed: {
    active() {
      return this.$store.state.admin.activeName;
    }
  },
  methods: {
    hanldeMenu(name, indexPath) {
      if (name === this.active) return;
      if (indexPath.length > 1) {
        this.oldIndex && this.$refs.menuNav.close(this.oldIndex)
        this.oldIndex = indexPath[0]
      } else {
        this.oldIndex && this.$refs.menuNav.close(this.oldIndex)
        this.oldIndex = ""
      }
      this.$emit("change-activeName", name);
      this.$router.push({
        name
      });
    }
  }
};
</script>

<style lang="less" scoped>
.nav-wrapper {
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #f8f8f8;
  border-right: 1px solid #e8e8e8;
  overflow: hidden;
  .asideLogo {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    cursor: default;
    color: #fff;
    background-color: #438eb9;
    overflow: hidden;
    img,
    span {
      vertical-align: middle;
    }
  }
  .el-menu {
    border: 0;
    transition: 0.3s all ease-in-out;
    .el-submenu {
      background-color: #f8f8f8;
      border-bottom: 1px solid #eee;
    }
    .el-menu-item {
      background-color: #f8f8f8;
      border-bottom: 1px solid #eee;
      transition: 0.3s all ease-in-out;
      i {
        color: #272626;
      }
    }
    .el-menu-item.is-active i {
      color: #2d8cf0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/nav.vue